import { SanityDividerPhoto } from '@data/sanity/queries/types/modules'
import Photo from '@components/photo'
import { backgroundColorClassMap } from '@lib/color'

type DividerPhotoProps = SanityDividerPhoto

const DividerPhoto = ({ photo, background }: DividerPhotoProps) => (
  <section
    className={`${background ? backgroundColorClassMap[background] : ''}`}
  >
    <div className="container">
      <Photo image={photo} className="w-full" imageClassName="w-full h-auto" />
    </div>
  </section>
)

export default DividerPhoto
